import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ToastInterface } from '~/component/toast/interfaces/toast.interface';
import { ToastsService } from '~/notifications/toasts/toasts.service';

@Component({
  selector: 'app-toasts-service-component',
  templateUrl: './toasts-service.component.html',
})
export class ToastsServiceComponent implements AfterViewInit, OnDestroy {
  private toastsSubscription: Subscription;
  public toastCollection: ToastInterface[] = [];

  constructor(private readonly toastsService: ToastsService) {}

  public ngAfterViewInit(): void {
    this.toastsSubscription = this.toastsService.onNewToast$.subscribe(
      (toast) => {
        this.toastCollection.push(toast);
      }
    );
  }

  public ngOnDestroy(): void {
    this.toastsSubscription?.unsubscribe();
  }

  public closeToast(index: number): void {
    this.toastCollection.splice(index, 1);
  }
}
